<app-community-links [links]="links()" [isVertical]="false" [isLoading]="isLoading()" />
